<template>
  <div class="sidebar-left">
    <div class="sidebar">
      <div class="sidebar-content email-app-sidebar">
        <div class="email-app-menu">
          <div class="form-group-compose text-center compose-btn">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              block
              @click="
                $emit('update:shall-show-email-compose-modal', true);
                $emit('close-left-sidebar');
              "
              v-if="
                userData.permissions && userData.permissions.permissions.length
              "
            >
              ارسال پیام
            </b-button>
          </div>
          <vue-perfect-scrollbar
            :settings="perfectScrollbarSettings"
            class="sidebar-menu-list scroll-area"
          >
            <!-- Filters -->
            <b-list-group class="list-group-messages">
              <b-list-group-item
                v-for="filter in emailFilters"
                :key="filter.title + $route.path"
                :to="filter.route"
                @click="
                  $emit('close-left-sidebar'),
                    $store.dispatch('appConfig/getEmailViewData', {})
                "
              >
                <div class="d-flex align-items-center">
                  <feather-icon :icon="filter.icon" size="18" class="mr-75" />
                  <span class="align-text-bottom line-height-1">{{
                    filter.title
                  }}</span>
                </div>
              </b-list-group-item>
            </b-list-group>

            <!-- Labels -->
            <h6 class="section-label mt-3 mb-1 px-2">نوع پیام</h6>

            <b-list-group class="list-group-labels">
              <b-list-group-item
                v-for="label in emailLabel"
                :key="label.title + $route.path"
                :to="label.route"
                @click="
                  $emit('close-left-sidebar'),
                    $store.dispatch('appConfig/getEmailViewData', {})
                "
              >
                <span
                  class="bullet bullet-sm mr-1"
                  :class="`bullet-${label.color}`"
                />
                <span>{{ label.title }}</span>
              </b-list-group-item>
            </b-list-group>
          </vue-perfect-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { BButton, BListGroup, BListGroupItem, BBadge } from "bootstrap-vue";
import { isDynamicRouteActive } from "@core/utils/utils";
import Ripple from "vue-ripple-directive";

export default {
  directives: {
    Ripple,
  },
  components: {
    // BSV
    BButton,
    BListGroup,
    BListGroupItem,
    BBadge,

    // 3rd Party
    VuePerfectScrollbar,
  },
  computed: {
    userData() {
      return this.$store.state.auth.userData || {};
    },
  },
  data() {
    return {
      perfectScrollbarSettings: {
        maxScrollbarLength: 60,
      },
      emailFilters: [
        {
          title: "صندوق پیام",
          icon: "MailIcon",
          route: { name: "apps-email" },
        },

        // {
        //   title: "Draft",
        //   icon: "Edit2Icon",
        //   route: { name: "apps-email-folder", params: { folder: "draft" } },
        // },
        // {
        //   title: "Starred",
        //   icon: "StarIcon",
        //   route: { name: "apps-email-folder", params: { folder: "starred" } },
        // },
        // {
        //   title: "Spam",
        //   icon: "InfoIcon",
        //   route: { name: "apps-email-folder", params: { folder: "spam" } },
        // },
        // {
        //   title: "Trash",
        //   icon: "TrashIcon",
        //   route: { name: "apps-email-folder", params: { folder: "trash" } },
        // },
      ],
    };
  },

  // created() {
  //   this.userData.permissions &&
  //     this.userData.permissions.permissions.length &&
  //     this.emailFilters.push({
  //       title: "ارسال شده",
  //       icon: "SendIcon",
  //       route: { name: "apps-email-folder", params: { folder: "sent" } },
  //     });
  // },
  setup() {
    const emailLabel = [
      {
        title: "سیستمی",
        color: "success",
        route: { name: "apps-email-label", params: { filters: "is_system" } },
      },

      {
               title: "غیر سیستمی",

        color: "info",
        route: { name: "apps-email-label", params: { filters: "isnot_system" }  },
      },
    ];

    const resolveFilterBadgeColor = (filter) => {
      if (filter === "Draft") return "light-warning";
      if (filter === "Spam") return "light-danger";
      return "light-primary";
    };

    return {
      // UI
      isDynamicRouteActive,
      resolveFilterBadgeColor,

      // Filter & Labels
      emailLabel,
    };
  },
};
</script>

<style></style>
